module.exports = __webpack_public_path__ + "img/effect.7bff3000.png";